import {
  MisaOutward,
  MisaOutwardDetail,
  MisaInward,
  MisaInwardDetail,
  MisaPurchase,
  MisaPurchaseDetail,
  InventoryItem,
  DeliveryOrder,
  MisaPUOrder,
  Vendor,
  OdooPartner,
  OdooProduct,
  OdooPOPayload,
} from "../types/misa";

// Token cố định cho Odoo API (nếu sau này cần dynamic thì đưa vào config)
// const ODOO_TOKEN =
//   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbiI6ImFkbWluIiwicGhvbmUiOmZhbHNlLCJlbWFpbCI6ImFkbWluQGV4YW1wbGUuY29tIiwidXNlcl9pZCI6MiwibmFtZSI6IkFkbWluaXN0cmF0b3IiLCJwYXJ0bmVyX2lkIjozLCJkYiI6Im5oYXRodW9jIiwiaWF0IjoxNzc1NDYwNzU2LCJqdGkiOiIxN2U4NWVmOC01NzQ2LTQyOGYtYjYyYy00OTAxYmI2M2RjZGEiLCJ2ZXIiOjEsImV4cCI6MjA5MDgyMDc1NiwiYXVkIjoiYXV0aF9qd3RfYXBpIiwiaXNzIjoiTWVkRWNvIn0.oQvS_8vnAdNK00f-1A9pfLEt8S8JOCBnxJHtSQnsmJk'
// const ODOO_BASE_URL = "https://nhathuoc-dev.medeco.vn/api/v2";

const ODOO_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbiI6ImFkbWluIiwicGhvbmUiOmZhbHNlLCJlbWFpbCI6ImFkbWluQGV4YW1wbGUuY29tIiwidXNlcl9pZCI6MiwibmFtZSI6IkFkbWluaXN0cmF0b3IiLCJwYXJ0bmVyX2lkIjozLCJkYiI6Im5oYXRodW9jIiwiaWF0IjoxNzc2MjQxNzIyLCJqdGkiOiI2OTYwODFlMC0xYTVkLTQ1MzktOTJkOC01NWQ2NTc5NDAyODgiLCJ2ZXIiOjEsImV4cCI6MjA2OTc4NDE3MjIsImF1ZCI6ImF1dGhfand0X2FwaSIsImlzcyI6Ik1lZEVjbyJ9.RIaVChyvxxyjPyYsLA0fRloic59jM2VjzlXmKLkcNzI'
const ODOO_BASE_URL = "https://nhathuoc-erp.yway.vn/api/v2";

const FILE_MISA_TOKEN =
  "https://docs.google.com/spreadsheets/d/1MQt7mn0RLwilk2VEMW9hVKw77gHUTXYfu3ZQk62NIAw/export?format=csv&gid=0";

export async function fetchMisaToken(): Promise<string> {
  try {
    const response = await fetch(FILE_MISA_TOKEN, { redirect: "follow" });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    let csvText = await response.text();
    csvText = csvText.replace(/^\uFEFF/, "");
    const lines = csvText.split(/\r?\n/);
    let token = lines[0]?.split(",")[0] || "";
    token = token
      .replace(/^['"]|['"]$/g, "")
      .replace(/[^\x20-\x7E]/g, "")
      .trim();
    return token;
  } catch (e) {
    console.error("❌ Error loading MISA token:", e);
    return "";
  }
}

export async function fetchMisaData(
  misaToken: string,
  fromDate: string,
  toDate: string,
  branchId: string,
): Promise<MisaOutward[]> {
  const filter = [
    {
      xtype: "filter",
      property: "RefDate",
      operator: 4,
      value: `${fromDate}T00:00:00`,
      type: 2,
      group: "RefDate",
    },
    {
      xtype: "filter",
      property: "RefDate",
      operator: 3,
      value: `${toDate}T23:59:59`,
      type: 2,
      addition: 1,
      group: "RefDate",
    },
    {
      xtype: "filter",
      isFilterRow: true,
      property: "RefType",
      operator: 0,
      value: 2905,
      type: 7,
      addition: 1,
      group: "RefTypeFFR",
    },
  ];
  const encodedFilter = encodeURIComponent(JSON.stringify(filter));
  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/Outwards?_dc=${Date.now()}&page=1&start=0&limit=5000&filter=${encodedFilter}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    const result = await response.json();
    return (
      result.Data?.filter(
        (item: MisaOutward) => item.BranchName === "Kho tổng",
      ) || []
    );
  } catch (error) {
    console.error("Lỗi khi gọi MISA API:", error);
    return [];
  }
}

export async function fetchMisaDetails(
  misaToken: string,
  refId: string,
  branchId: string,
): Promise<MisaOutwardDetail[]> {
  const detailUrl = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/Outwards/OutwardDetails/${refId}?_dc=${Date.now()}&page=1&start=0&limit=500`;
  try {
    const response = await fetch(detailUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const detailResult = await response.json();
    return detailResult.data || detailResult.Data || [];
  } catch (e) {
    console.error("Lỗi khi lấy chi tiết phiếu:", e);
    return [];
  }
}

export async function fetchMisaDataNhapKho(
  misaToken: string,
  fromDate: string,
  toDate: string,
  branchId: string,
): Promise<MisaInward[]> {
  const filter = [
    {
      xtype: "filter",
      property: "RefDate",
      operator: 4,
      value: `${fromDate}T00:00:00`,
      type: 2,
      group: "RefDate",
    },
    {
      xtype: "filter",
      property: "RefDate",
      operator: 3,
      value: `${toDate}T23:59:59`,
      type: 2,
      addition: 1,
      group: "RefDate",
    },
    {
      xtype: "filter",
      isFilterRow: true,
      property: "RefType",
      operator: 0,
      value: 2094,
      type: 7,
      addition: 1,
      group: "RefTypeFFR",
    },
  ];
  const encodedFilter = encodeURIComponent(JSON.stringify(filter));
  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/INInwards?_dc=${Date.now()}&page=1&start=0&limit=5000&filter=${encodedFilter}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    const result = await response.json();
    return result.Data || [];
  } catch (error) {
    console.error("Lỗi khi gọi MISA API nhập kho:", error);
    return [];
  }
}

export async function fetchMisaInwardDetails(
  misaToken: string,
  refId: string,
  branchId: string,
): Promise<MisaInwardDetail[]> {
  const detailUrl = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/INInwards/INInwardDetail/${refId}?_dc=${Date.now()}&page=1&start=0&limit=500`;
  try {
    const response = await fetch(detailUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const detailResult = await response.json();
    return detailResult.data || detailResult.Data || [];
  } catch (e) {
    console.error("Lỗi khi lấy chi tiết phiếu nhập kho:", e);
    return [];
  }
}

export async function fetchMisaDataNhapHang(
  misaToken: string,
  fromDate: string,
  toDate: string,
  branchId: string,
): Promise<MisaPurchase[]> {
  const filter = [
    {
      xtype: "filter",
      property: "RefDate",
      operator: 4,
      value: `${fromDate}T00:00:00`,
      type: 2,
      group: "RefDate",
    },
    {
      xtype: "filter",
      property: "RefDate",
      operator: 3,
      value: `${toDate}T23:59:59`,
      type: 2,
      addition: 1,
      group: "RefDate",
    },
    {
      xtype: "filter",
      isFilterRow: true,
      property: "RefType",
      operator: 0,
      value: 301,
      type: 7,
      addition: 1,
      group: "RefTypeFFR",
    },
  ];
  const encodedFilter = encodeURIComponent(JSON.stringify(filter));
  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/INInwards?_dc=${Date.now()}&page=1&start=0&limit=5000&filter=${encodedFilter}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    const result = await response.json();
    return result.Data || [];
  } catch (error) {
    console.error("Lỗi khi gọi MISA API nhập hàng:", error);
    return [];
  }
}

export async function fetchMisaPurchaseDetails(
  misaToken: string,
  refId: string,
  branchId: string,
): Promise<MisaPurchaseDetail[]> {
  const detailUrl = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/invoices/detail/${refId}?_dc=${Date.now()}&page=1&start=0&limit=500`;
  try {
    const response = await fetch(detailUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const detailResult = await response.json();
    return detailResult.data || detailResult.Data || [];
  } catch (e) {
    console.error("Lỗi khi lấy chi tiết phiếu nhập hàng:", e);
    return [];
  }
}

export async function fetchDeliveryOrders(
  misaToken: string,
  fromDate: string,
  toDate: string,
  refNoFilter?: string,
): Promise<DeliveryOrder[]> {
  const filter: any[] = [];
  if (refNoFilter) {
    filter.push({
      xtype: "filter",
      isFilterRow: true,
      property: "RefNo",
      operator: 8,
      value: refNoFilter,
      type: 1,
    });
  }

  const params = new URLSearchParams({
    _dc: String(Date.now()),
    listTagID: "",
    filterDateType: "2",
    fromDate: `${fromDate}T00:00:00`,
    toDate: `${toDate}T23:59:59`,
    page: "1",
    start: "0",
    limit: "5000",
    filter: JSON.stringify(filter),
  });

  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg1/api/DeliveryLedger?${params.toString()}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        companycode: "nhathuocpharceco",
      },
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const result = await response.json();
    return result.Data || result.data || [];
  } catch (error) {
    console.error("Lỗi khi gọi API DeliveryLedger:", error);
    return [];
  }
}

export async function fetchPUOrders(
  misaToken: string,
  fromDate: string,
  toDate: string,
  branchId: string,
): Promise<MisaPUOrder[]> {
  const filter = [
    {
      xtype: "filter",
      property: "RefDate",
      operator: 4,
      value: `${fromDate}T00:00:00`,
      type: 2,
      group: "RefDate",
    },
    {
      xtype: "filter",
      property: "RefDate",
      operator: 3,
      value: `${toDate}T23:59:59`,
      type: 2,
      addition: 1,
      group: "RefDate",
    },
  ];
  const encodedFilter = encodeURIComponent(JSON.stringify(filter));
  // Default limit 50 as in example, though we might want to increase it to 5000 similar to other APIs, but keeping the requested format for now.
  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/PUOrders?_dc=${Date.now()}&page=1&start=0&limit=5000&filter=${encodedFilter}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    const result = await response.json();
    return result.Data || result.data || [];
  } catch (error) {
    console.error("Lỗi khi gọi MISA API PUOrders:", error);
    return [];
  }
}

export async function fetchPUOrderDetails(
  misaToken: string,
  refId: string,
  branchId: string,
): Promise<any[]> {
  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/PUOrders/Details/${refId}?_dc=${Date.now()}&page=1&start=0&limit=500`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const result = await response.json();
    return result.Data || result.data || [];
  } catch (error) {
    console.error(`Lỗi khi lấy chi tiết PO ${refId}:`, error);
    return [];
  }
}

export async function fetchVendors(
  misaToken: string,
  branchId: string,
): Promise<Vendor[]> {
  const filter = [
    {
      xtype: "filter",
      property: "Type",
      operator: 0,
      value: 1,
      type: 7,
      isFilterRow: true,
      group: "TypeFFR",
    },
    {
      xtype: "filter",
      isFilterRow: true,
      property: "Inactive",
      operator: 0,
      value: 0,
      type: 7,
    },
  ];
  const encodedFilter = encodeURIComponent(JSON.stringify(filter));
  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/Vendors?_dc=${Date.now()}&inventoryItemCategoryID=00000000-0000-0000-0000-000000000000&page=1&start=0&limit=5000&filter=${encodedFilter}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    const result = await response.json();
    return result.Data || result.data || [];
  } catch (error) {
    console.error("Lỗi khi lấy danh sách nhà cung cấp:", error);
    return [];
  }
}

type ApiResponse = {
  total?: number;
  data?: InventoryItem[];
};

const INVENTORY_BASE_URL =
  "https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/InventoryItem";

export async function fetchInventory(
  misaToken: string,
  params: Record<string, any>,
): Promise<ApiResponse> {
  const queryParams = {
    _dc: Date.now(),
    page: params.page || 1,
    limit: params.limit || 100,
    inventoryItemCategoryID: "00000000-0000-0000-0000-000000000000",
    branchID: "66847e41-5b66-4529-b955-e63c7e8b50b0",
    isOutStock: 0,
    start: 0,
    sort: '[{"property":"InventoryItemName","direction":"ASC"}]',
    filter:
      '[{"xtype":"filter","isFilterRow":true,"property":"Inactive","operator":0,"value":0,"type":7}]',
  };

  const url = `${INVENTORY_BASE_URL}?_dc=${queryParams._dc}&page=${
    queryParams.page
  }&start=${queryParams.start}&limit=${
    queryParams.limit
  }&inventoryItemCategoryID=${encodeURIComponent(
    queryParams.inventoryItemCategoryID,
  )}&branchID=${encodeURIComponent(
    queryParams.branchID,
  )}&isOutStock=${encodeURIComponent(
    queryParams.isOutStock,
  )}&sort=${encodeURIComponent(queryParams.sort)}&filter=${queryParams.filter}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": "66847e41-5b66-4529-b955-e63c7e8b50b0",
      },
    });
    const json = await response.json();

    const total = json?.total || json?.Total || 0;
    const data = json?.data || json?.Data || [];
    return { total, data };
  } catch (e) {
    console.error("Lỗi khi lấy dữ liệu hàng tồn kho:", e);
    return {};
  }
}

// ─── Odoo API ─────────────────────────────────────────────────────────────────

/**
 * Lấy toàn bộ nhà cung cấp từ Odoo (phân trang tự động).
 * Môi trường: nhathuoc-dev.medeco.vn
 */
export async function fetchOdooVendors(): Promise<OdooPartner[]> {
  const pageSize = 10000;
  let page = 1;
  const all: OdooPartner[] = [];

  try {
    while (true) {
      const url = `${ODOO_BASE_URL}/res.partner?page=${page}&size=${pageSize}&order=id+desc&partner_type=vendor`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${ODOO_TOKEN}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error(`Odoo API error: ${response.status}`);
      const json = await response.json();
      console.log("🔍 Odoo raw response (page", page, "):", json);

      // Lấy mảng records - thử nhiều field name phổ biến
      let records: OdooPartner[] = [];
      if (Array.isArray(json))               records = json;
      else if (Array.isArray(json.data))     records = json.data;
      else if (Array.isArray(json.content))  records = json.content;
      else if (Array.isArray(json.records))  records = json.records;
      else if (Array.isArray(json.items))    records = json.items;
      else {
        console.warn("⚠️ Odoo API trả về cấu trúc không xác định:", json);
        break;
      }

      const total: number = json.total ?? json.totalRecords ?? json.count ?? records.length;

      all.push(...records);

      if (all.length >= total || records.length < pageSize) break;
      page++;
    }
    console.log(`📦 Odoo Vendors: ${all.length} nhà cung cấp`);
    return all;
  } catch (error) {
    console.error("Lỗi khi lấy nhà cung cấp Odoo:", error);
    return [];
  }
}

/**
 * Tìm sản phẩm Odoo theo mã SKU (default_code).
 * VD: fetchOdooProduct("AVMKM03010013")
 */
export async function fetchOdooProduct(skuCode: string): Promise<OdooProduct[]> {
  if (!skuCode?.trim()) return [];
  try {
    const url = `${ODOO_BASE_URL}/pos/product.product?search=${encodeURIComponent(skuCode.trim())}&size=20&is_product_reward=false`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${ODOO_TOKEN}`,
        "Content-Type": "application/json",
        "x-store-id": "1",
      },
    });
    if (!response.ok) throw new Error(`Odoo product API error: ${response.status}`);
    const json = await response.json();

    // Parse array từ nhiều dạng response
    let products: OdooProduct[] = [];
    if (Array.isArray(json))              products = json;
    else if (Array.isArray(json.data))    products = json.data;
    else if (Array.isArray(json.content)) products = json.content;
    else if (Array.isArray(json.records)) products = json.records;
    else if (Array.isArray(json.items))   products = json.items;

    return products;
  } catch (error) {
    console.error(`Lỗi khi tìm sản phẩm Odoo (${skuCode}):`, error);
    return [];
  }
}

/**
 * Tạo Purchase Order gửi lên Odoo
 */
export async function createOdooPurchaseOrder(payload: OdooPOPayload): Promise<any> {
  const url = `${ODOO_BASE_URL}/purchase.order`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${ODOO_TOKEN}`,
        "Content-Type": "application/json",
        "x-store-id": "1",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errText = await response.text();
      throw new Error(`Lỗi tạo PO trên Odoo: ${response.status} - ${errText}`);
    }
    const json = await response.json();
    return json;
  } catch (error) {
    console.error("Lỗi khi gửi PO lên Odoo:", error);
    throw error;
  }
}

